import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { endpoints } from '@/api';
import { isGuest, useAuth } from '@/stores/auth';
import { toast } from '@/stores/toasts';

/**
 * A guest who signed in with an account that already existed (claimed)
 * finishes its date as the guest; once out of the call, its dates move to
 * that account and this browser switches to it.
 */
export function GuestSwitcher() {
  const me = useAuth((s) => s.me);
  const setSession = useAuth((s) => s.setSession);
  const qc = useQueryClient();
  const { pathname } = useLocation();
  const busy = useRef(false);
  useEffect(() => {
    if (!me?.claimed || !isGuest(me) || pathname.startsWith('/call/') || busy.current) return;
    busy.current = true;
    endpoints
      .guestSwitch()
      .then((r) => {
        setSession(r.access_token, r.user);
        void qc.invalidateQueries();
        toast.success(`Welcome back, ${r.user.display_name}`, 'Your date is saved to your account.');
      })
      .catch(() => undefined) // in a call, or offline: try again on the next page
      .finally(() => {
        busy.current = false;
      });
  }, [me, pathname, qc, setSession]);
  return null;
}
